"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _htmlmap = _interopRequireDefault(require("./htmlmap.js"));

var _helpers = require("./helpers");

var _excluded = ["type", "subtype", "content", "meta_content", "atts"],
    _excluded2 = ["type", "subtype", "atts", "content"],
    _excluded3 = ["blocks"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function perf2html(perfDocument, sequenceId) {
  var htmlMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _htmlmap.default;

  var contentChildren = content => {
    var _content$reduce;

    return (_content$reduce = content === null || content === void 0 ? void 0 : content.reduce((contentHtml, element) => contentHtml += typeof element === "string" ? element : contentElementHtml(element), "")) !== null && _content$reduce !== void 0 ? _content$reduce : "";
  };

  var contentHtml = (content, className) => content ? (0, _helpers.createElement)({
    tagName: "span",
    classList: [className],
    children: content === null || content === void 0 ? void 0 : content.reduce((contentsHtml, element) => typeof element === "string" ? contentsHtml += element : contentsHtml += contentElementHtml(element), "")
  }) : "";

  var contentElementHtml = element => {
    var {
      type,
      subtype,
      content,
      meta_content,
      atts
    } = element,
        props = _objectWithoutProperties(element, _excluded);

    var attsProps = (0, _helpers.handleAtts)(atts);
    var subtypes = (0, _helpers.handleSubtypeNS)(subtype);
    var {
      classList,
      tagName,
      id
    } = (0, _helpers.mapHtml)({
      props: _objectSpread({
        type,
        subtype,
        atts
      }, props),
      htmlMap
    });

    var innerHtml = content => {
      var getters = {
        markHtml: () => ["chapter", "verses"].includes(subtype) ? atts.number : "",
        wrapperHtml: () => contentChildren(content) + contentHtml(meta_content, "meta-content")
      };
      var getContentHtml = getters["".concat(type, "Html")];
      return typeof getContentHtml === "function" ? getContentHtml() : "";
    };

    return (0, _helpers.createElement)({
      tagName,
      id,
      classList,
      dataset: _objectSpread(_objectSpread(_objectSpread({
        type
      }, subtypes), attsProps), props),
      children: innerHtml(content)
    });
  };

  var blockHtml = block => {
    var {
      type,
      subtype,
      atts,
      content
    } = block,
        props = _objectWithoutProperties(block, _excluded2);

    var attsProps = (0, _helpers.handleAtts)(atts);
    var subtypes = (0, _helpers.handleSubtypeNS)(subtype);
    var {
      classList,
      tagName,
      id
    } = (0, _helpers.mapHtml)({
      props: _objectSpread({
        type,
        subtype,
        atts
      }, props),
      htmlMap
    });
    return (0, _helpers.createElement)({
      tagName,
      id,
      classList,
      dataset: _objectSpread(_objectSpread(_objectSpread({
        type
      }, subtypes), attsProps), props),
      children: contentChildren(content)
    });
  };

  var sequenceHtml = (perfSequence, sequenceId) => {
    var {
      blocks
    } = perfSequence,
        props = _objectWithoutProperties(perfSequence, _excluded3);

    var {
      classList,
      tagName
    } = (0, _helpers.mapHtml)({
      props: _objectSpread(_objectSpread({}, props), {}, {
        subtype: "sequence"
      }),
      htmlMap
    });
    return (0, _helpers.createElement)({
      tagName,
      id: "".concat(sequenceId),
      classList: classList,
      dataset: props,
      children: blocks === null || blocks === void 0 ? void 0 : blocks.reduce((blocksHtml, block) => blocksHtml += blockHtml(block), "")
    });
  };

  var perfSequence = perfDocument.sequences[sequenceId];
  return sequenceHtml(perfSequence, sequenceId);
}

var _default = perf2html;
exports.default = _default;